__turbopack_context__.v({
  "filter_container": "styles-module-scss-module__OpsaZa__filter_container",
  "grid_list": "styles-module-scss-module__OpsaZa__grid_list",
  "is_desktop": "styles-module-scss-module__OpsaZa__is_desktop",
  "is_mobile": "styles-module-scss-module__OpsaZa__is_mobile",
  "label": "styles-module-scss-module__OpsaZa__label",
  "second_row_filters": "styles-module-scss-module__OpsaZa__second_row_filters",
  "submit_button": "styles-module-scss-module__OpsaZa__submit_button",
});
